<template>
  <div :class="styleMain">
    <el-button plain v-for="category in categories" :key="category.value" @click="handleClick(category)">
      <svgicon :name="'sport/football/match/' + category.icon" original />
      {{ category.label }}
    </el-button>
  </div>
</template>

<script>
import { stopwatch } from '@/helpers/format'
import { actionCategories } from '@/store/model/sport/football/ActionCategories'

export default {
  name: 'SportFootballMatchTeamButtons',
  props: {
    match: Object,
    team: Object
  },
  computed: {
    categories () {
      if (this.match?.penaltyShootOut) {
        return actionCategories.listDisplayButtonPenaltyShootOut
      } else {
        return actionCategories.listDisplayButton
      }
    },

    styleMain () { return ['sportFootballMatchTeamButtons', this.match?.homeAway(this.team)] }
  },
  methods: {
    handleClick (action) {
      const time = stopwatch(this.match.dateStartOffset, this.$store.getters['Server/live'], this.match.statusId)
      const newAction = {
        teamId: this.team.id,
        team2Id: this.team.id === this.match.teamHomeId ? this.match.teamAwayId : this.match.teamHomeId,
        matchId: this.match.id,
        statusId: this.match.statusId,
        date: this.$store.getters['Server/live'].toISOString(),
        active: 1,
        minute: time ? parseInt(time.split(':')[0]) + 1 : null
      }

      Object.assign(newAction, action.rules)
      if (action.rulesPost) {
        Object.assign(newAction, action.rulesPost)
      }

      this.$store.dispatch('Sport/Football/Match/postAction', newAction)
    }
  }
}
</script>

<style>
.sportFootballMatchTeamButtons{
  margin-top:30px;
  display: grid;
  grid-template-columns: repeat(auto, 20px, auto);
}
.sportFootballMatchTeamButtons button{
  position:relative;
  padding: 5px 5px 5px 40px;
  width: 140px;
  height:42px;
  margin-bottom:10px;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  white-space: normal;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  color: var(--color-font-black)
}
.sportFootballMatchTeamButtons .el-button + .el-button{
    margin-left: 0;
}
.sportFootballMatchTeamButtons button:nth-child(odd){
  grid-column:1;
  justify-self: end;
}
.sportFootballMatchTeamButtons button:nth-child(even){
  grid-column:3;
  justify-self: start
}
.sportFootballMatchTeamButtons button svg{
  position:absolute;
  display:block;
  top:6px;
  left:5px;
  width:30px;
  height:30px
}
.sportFootballMatchTeamButtons .el-button.is-plain:focus,
.sportFootballMatchTeamButtons .el-button.is-plain:hover {
    border-color: var(--color-team-home);
    color: var(--color-team-home);
}
.sportFootballMatchTeamButtons.away .el-button.is-plain:focus,
.sportFootballMatchTeamButtons.away .el-button.is-plain:hover {
    border-color: var(--color-team-away);
    color: var(--color-team-away);
}
</style>
